import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { faList, faRectangleList, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import { useAuth0 } from '@auth0/auth0-react';
import EmbeddedList from 'components/common/EmbeddedList';
import { OBJ } from 'constants';
import { Can } from '@casl/react';
import { ability } from 'abilities/AbilityProvider';

function TenantSelector() {
    const { t } = useTranslation();
    const { logout } = useAuth0();    
    const [view, setView] = useState('TileView')

    return (
        <Container fluid className="vh-100 loginForm background-container">
            <Row>
                <Col md="8">
                    <h1 className="pt-3 px-3">{t("settings.header.selectTenant")}</h1>
                </Col>
                <Col md="4" className="text-end">
                    <Can I="view" a="TenantList" ability={ability}>
                        <IconButtonWithTooltip 
                            translationId={view==='TileView' ? 'tenants.view.list': 'tenants.view.tile' } 
                            icon={view==='TileView' ? faList: faRectangleList } 
                            onClick={() => setView(view==='TileView' ? 'ListView' : 'TileView')} 
                            type="Button"/>
                    </Can>
                    <IconButtonWithTooltip translationId='menu.logout' icon={faRightFromBracket} onClick={logout} type="Button"/>
                </Col>
            </Row>
            <Row className="pt-3 px-3">
                <EmbeddedList type={OBJ.TENANTS} listView={view}/>
            </Row>
        </Container>
    );
}

export default TenantSelector;